/**
 * A record's name by the rule it has always had: its display name, else its
 * name, else its zone's name, else "Player 3". The title falls back to this
 * when none of its fields has a value ({@see recordHeadingText}).
 */

function displayName(value: unknown): string {
    if (value && typeof value === 'object') {
        const name = (value as Record<string, unknown>).display_string ?? (value as Record<string, unknown>).name;
        return typeof name === 'string' ? name : '';
    }
    return typeof value === 'string' ? value : '';
}

/** The record's name, falling back to its zone's name, then to "Player 3". */
export function recordTitle(record: Record<string, unknown> | null, noun: string, recordId: number | string): string {
    if (!record) return `${noun} ${recordId}`;
    return (
        displayName(record.display_string) ||
        displayName(record.name) ||
        displayName(record.location_zone) ||
        `${noun} ${recordId}`
    );
}
